/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import Component from '@ember/component';
import computedFindBy from 'cio/utils/computed-find-by';
import _stateInfos from 'cio/utils/state-label-map';

@tagName('')
export default class CioDeliveryStateItem extends Component {
  item = null;
  option = null;

  // TODO: Fix after item/option discussion
  @computed('item', 'option')
  get actualOption() {
    return this.item ?? this.option;
  }

  _stateInfos = _stateInfos;

  @computedFindBy('_stateInfos', 'state', 'actualOption') _stateInfo;

  get label() {
    return this._stateInfo.label ?? this._stateInfo.state;
  }
}
